import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { HomeHero } from '../components/home/HomeHero';
import { TrustStrip } from '../components/home/TrustStrip';
import { StatsBand } from '../components/home/StatsBand';
import { ServicesOverview } from '../components/home/ServicesOverview';
import { WhoWeCareFor } from '../components/home/WhoWeCareFor';
import { WhyChooseUs } from '../components/home/WhyChooseUs';
import { FaqPreview } from '../components/home/FaqPreview';
import { TestimonialsDark } from '../components/shared/TestimonialsDark';
import { ProcessSteps } from '../components/shared/ProcessSteps';
import { ServiceAreaSection } from '../components/shared/ServiceAreaSection';
import { ContactSection } from '../components/shared/ContactSection';
import { CtaBand } from '../components/shared/CtaBand';
export function Home() {
  useDocumentMeta('home');
  return <>
      <HomeHero data-id="element-548" data-mp="3owcejc9j541q" />
      <TrustStrip data-id="element-549" data-mp="3ovucu043lxmf" />
      <StatsBand data-id="element-550" data-mp="3ovatceysv16a" />
      <ServicesOverview data-id="element-551" data-mp="3oyylb9oljfiw" />
      <WhoWeCareFor data-id="element-552" data-mp="30wjd0qrxiw5e" />
      <WhyChooseUs data-id="element-553" data-mp="30x1jeg8b2qr1" />
      <TestimonialsDark data-id="element-554" data-mp="30vgp8rpwl9tp" />
      <ProcessSteps data-id="element-555" data-mp="30up0o0uq4ccx" />
      <ServiceAreaSection data-id="element-556" data-mp="2vxottnq1v5kr" />
      <FaqPreview data-id="element-557" data-mp="2vxf503gqr4gn" />
      <ContactSection data-id="element-558" data-mp="2vyzxzoneqfce" />
      <CtaBand data-id="element-559" data-mp="2vvluue6x623w" />
    </>;
}